import { Component, OnInit, ViewChild, ViewContainerRef, ComponentFactoryResolver, AfterContentInit, AfterViewInit } from '@angular/core';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuTypeService } from '../../core/services/menu-type.service';
import { EventPreferences } from '../../core/models/event-preferences';
import { FileUpload } from '../../core/models/fileupload';
import { ContentsMandatory } from '../../core/models/contents-mandatory';
import { RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { __core_private_testing_placeholder__ } from '@angular/core/testing';
import { EventsService } from '../../core/services/events.service';
import { ExtraService } from '../../core/services/extra.service';
import * as firebase from 'firebase';

import { Constants } from '../../core/config/Constants';
import { CustomLogo } from '../../core/models/customlogo';
import { Menu } from '../../core/models/menu';
import { VenueMap } from '../../core/models/venue-detail';
import { SplashMap } from '../../core/models/splash-map';
import { SliderComponent } from '../../layout/slider/slider.component';
import { DragulaService } from 'ng2-dragula/ng2-dragula';
import { HeaderImageSliderComponent } from '../../layout/header-image-slider/header-image-slider.component';

@Component({
    selector: 'app-menu-type',
    templateUrl: './menu-type.html',
    styleUrls: ['./menu-type.css'],
    providers: [DragulaService, MenuTypeService, EventsService]
})

export class MenuTypeComponent implements OnInit {

    @ViewChild('template', { read: ViewContainerRef }) template: ViewContainerRef;

    file_error_summary = Constants.VIDEO_SIZE_ERROR_MESSAGE_SUMMARY;
    file_error_detail = Constants.VIDEO_SIZE_ERROR_MESSAGE_DETAIL;
    file_size = Constants.VIDEO_SIZE;


    buttonMessage = Constants.SUBMIT_BUTTON_MESSAGE;
    pageTitle: string = "Menu Type";
    errorMessage: string;
    theme_type: any;
    matchCustomLogoFileName: string;
    evntID: string = '';
    menu_content_mandatory_list_length: number;
    menu_content_mandatory_list_imageSlider_length: number = 0;
    custom_logo_id: string;
    background_id: string;
    menuid: string;

    contentsMandatory = new ContentsMandatory();
    contentsMandatory1 = new ContentsMandatory();
    contentsMandatory2 = new ContentsMandatory();
    contentsMandatory3 = new ContentsMandatory();

    preferences = new EventPreferences();
    splashMap = new SplashMap();
    venue = new VenueMap();

    event1: boolean = true;
    eventType1: boolean = true;
    eventType2: boolean = true;
    eventType3: boolean = true;
    eventType4: boolean = true;

    showLogo: boolean = false;
    showBgType: boolean = false;
    sectionName: boolean = false;

    customLogoOnEveryPage: boolean = false;
    tintLogo: boolean = false;
    // hasSecondaryLogo: boolean = false;
    widthIos: number;

    eventypeBg: boolean = false;

    removeCard: boolean = true;
    selectCardFlag: boolean = false;
    iconCardFlag: boolean = false;
    iconTextFlag: boolean = false;

    // prop: string = 'square';
    bgprop: string = 'partial';
    bgprop1: string = 'BG001';
    prop1: string = 'showForm1';
    prop2: string;
    disableButton: boolean = true;
    currentFileUpload1: FileUpload;
    currentFileUpload2: FileUpload;
    currentFileUpload3: FileUpload;
    imageFile: File = null;
    progress: { percentage: number } = { percentage: 0 }

    message: string = null;
    errorMessages: string[];
    isError: boolean = false;
    confirmMessage: string = '';

    color: string = null;
    bgColor1: string = null;
    cardColorValue: string = null;
    menuIconColor: string = null;
    menuIiconTextColorValue: string = null;

    categoryName = Constants.CONTENT_M_TYPE_MENU;

    images: string[] = new Array();
    currentFiles = [];
    tagName = 'dragId';
    uploadprogress: number = null;
    uploadFileName: string = null;

    blurImage: boolean = false;
    blurIndex: number = null;
    expComponent: any;
    menu_type_chk: string = null;
    hide_text: boolean = false;

    constructor(private dragula: DragulaService, private _cfr: ComponentFactoryResolver, private router: Router, private extraService: ExtraService, private eventsService: EventsService,
        private route: ActivatedRoute, private menuTypeService: MenuTypeService) {

        const bag: any = this.dragula.find(this.tagName);
        if (bag !== undefined) this.dragula.destroy(this.tagName);
        this.dragula.setOptions(this.tagName, {});
    }

    addImageSlider() {

        var imageSlider = this._cfr.resolveComponentFactory(HeaderImageSliderComponent);
        this.expComponent = this.template.createComponent(imageSlider);

        this.expComponent.instance.eventId = this.evntID;
        this.expComponent.instance.cName = this.categoryName;
        this.expComponent.instance.categoryName = this.preferences.menu.menu_header_type;
        if (!this.preferences.menu.menu_content_mandatory_list) {
            this.preferences.menu.menu_content_mandatory_list = new Array<string>();
        }
        this.expComponent.instance.cmListArray = this.preferences.menu.menu_content_mandatory_list;
    }

    removeSlider() {
        if (this.expComponent) {
            this.expComponent.destroy();
        }
    }

    log(event: boolean) { }
    uploadedFiles: any[] = [];
    menuTypeList: any[] = [];

    // Sudhir Sir code start ------------------------------------------------

    galleryOptions: NgxGalleryOptions[];
    galleryImages: NgxGalleryImage[];

    ngOnInit(): void {

        let count = 0;
        this.extraService.castMenuTypeSubmit$.subscribe(isShow => {
            setTimeout(() => {
                this.disableButton = isShow;
                if (!this.disableButton) {
                    this.message = 'File Uploading...';
                } else {
                    if (count > 0) {
                        this.message = 'File Uploaded Successfully';
                    }
                    count++;
                }
            });
        });

        this.route.params.subscribe(params => {
            this.getResponse(params['eventId']);
        });


        this.galleryOptions = [
            {
                width: '100%',
                height: '400px',
                thumbnailsColumns: 6,
                imageAnimation: NgxGalleryAnimation.Slide
            },
            // max-width 800
            {
                breakpoint: 800,
                width: '100%',
                height: '600px',
                imagePercent: 80,
                thumbnailsPercent: 20,
                thumbnailsMargin: 20,
                thumbnailMargin: 20
            },
            // max-width 400
            {
                breakpoint: 400,
                preview: false
            }
        ];

        this.galleryImages = [
            {
                small: 'assets/img/partyImg1.jpg',
                medium: 'assets/img/partyImg2.jpg',
                big: 'assets/img/partyBanner.jpg'
            }
        ];


    }

    /// Color code Start ///////
    receiveColor(event) {
        console.log(event);
        if (event) {
            this.preferences.custom_logo.custom_logo_tint_color = event.splash_cutom_bg_color;
        }
    }

    receiveBgColor(event) {
        console.log(event);
        if (event) {
            this.preferences.menu.menu_bg_color = event.splash_cutom_bg_color;
        }
    }

    receiveCardColor(event) {
        console.log(event);
        if (event) {
            this.preferences.menu.menu_icon_card_color = event.splash_cutom_bg_color;
        }
    }

    receiveIconColor(event) {
        console.log(event);
        if (event) {
            this.preferences.menu.menu_icon_color = event.splash_cutom_bg_color;
        }
    }

    receiveIconTextColor(event) {
        console.log(event);
        if (event) {
            this.preferences.menu.menu_icon_text_color = event.splash_cutom_bg_color;
        }
    }


    /// Color code End ///////

    // Sudhir Sir code End ------------------------------------------------

    getResponse(eventId) {
        if (eventId) {
            this.evntID = eventId;
            this.contentsMandatory1.eventId = eventId;

            this.extraService.setCurrentEventId(eventId);
            this.extraService.changeStateofSideBarButton(true);
            this.extraService.changeSideBar(true);

            this.setPreferencesData(eventId);
            //this.setEventMenuTypeData(eventId);

        }
    }

    setPreferencesData(eventId) {
        this.menuTypeService.getPreferencesData(eventId).subscribe(event => {
            if (event) {

                this.preferences = event;
                console.log(this.preferences)

                if (event.custom_logo) {

                    if (event.custom_logo.hideText) {
                        this.hide_text = event.custom_logo.hideText;
                    }
                    if (event.custom_logo.custom_logo_has_tint) {
                        this.tintLogo = event.custom_logo.custom_logo_has_tint;
                    }
                    if (event.custom_logo.custom_logo_tint_color) {
                        this.color = event.custom_logo.custom_logo_tint_color;
                    }
                    if (event.custom_logo.has_custom_logo) {
                        this.showLogo = event.custom_logo.has_custom_logo;
                        this.widthIos = event.custom_logo.widthIos;
                    }
                    // this.hasSecondaryLogo = event.custom_logo.hasSecondaryLogo;
                }

                if (event.menu) {

                    if (event.menu.menuIconType) {
                        this.menu_type_chk = event.menu.menuIconType;
                    }

                    if (event.menu.menu_has_custom_bg) {
                        this.showBgType = event.menu.menu_has_custom_bg;
                    }
                    if (event.menu.menu_bg_type) {
                        this.bgprop1 = event.menu.menu_bg_type;
                    }
                    if (event.menu.menu_bg_color) {
                        this.bgColor1 = event.menu.menu_bg_color;
                    }
                    if (event.menu.has_custom_card_color) {
                        this.selectCardFlag = this.preferences.menu.has_custom_card_color = event.menu.has_custom_card_color;
                    }
                    if (event.menu.menu_icon_card_color) {
                        this.cardColorValue = event.menu.menu_icon_card_color;
                    }
                    if (!event.menu.menu_icon_remove_card) {
                        this.removeCard = this.preferences.menu.menu_icon_remove_card = event.menu.menu_icon_remove_card;
                    }
                    if (event.menu.menu_icon_remove_card) {
                        this.removeCard = this.preferences.menu.menu_icon_remove_card = event.menu.menu_icon_remove_card;
                    }
                    if (event.menu.has_custom_icon_color) {
                        this.iconCardFlag = this.preferences.menu.has_custom_icon_color = event.menu.has_custom_icon_color;
                    }
                    if (event.menu.menu_icon_color) {
                        this.menuIconColor = event.menu.menu_icon_color;
                    }
                    if (event.menu.has_custom_icon_text_color) {
                        this.iconTextFlag = this.preferences.menu.has_custom_icon_text_color = event.menu.has_custom_icon_text_color;
                    }
                    if (event.menu.menu_icon_text_color) {
                        this.menuIiconTextColorValue = event.menu.menu_icon_text_color;
                    }
                    if (event.menu.menu_bg_image_has_blur) {
                        this.blurImage = this.preferences.menu.menu_bg_image_has_blur = event.menu.menu_bg_image_has_blur;
                    }
                    if (event.menu.menu_bg_image_blur_index) {
                        this.blurIndex = this.preferences.menu.menu_bg_image_blur_index = event.menu.menu_bg_image_blur_index;
                    }
                }

                this.splashMap = event.splash_map;
                this.venue = event.venue;
                this.theme_type = this.preferences.theme.theme_type = event.theme.theme_type;

                if (event.menu && event.menu.menu_has_header) {
                    this.sectionName = event.menu.menu_has_header;
                    if (event.menu.menu_header_type) {
                        if (event.menu.menu_header_type === 'image') {
                            this.prop2 = 'Image';
                        } else if (event.menu.menu_header_type === 'imageSlider') {
                            this.prop2 = 'Image Slider';
                            setTimeout(() => {
                                this.addImageSlider();
                            }, 2000);
                        } else if (event.menu.menu_header_type === 'video') {
                            this.prop2 = 'Video';
                        } else if (event.menu.menu_header_type === 'youtubeVideo') {
                            this.prop2 = 'Youtube';
                        }
                    }
                }

                if (event.custom_logo && event.custom_logo.custom_logo_id) {
                    this.custom_logo_id = this.preferences.custom_logo.custom_logo_id = event.custom_logo.custom_logo_id;
                    this.setContentMendatoryCustomLogoData(this.preferences.custom_logo.custom_logo_id, eventId);
                } if (event.menu && event.menu.menu_bg_image_id) {
                    this.background_id = this.preferences.menu.menu_bg_image_id = event.menu.menu_bg_image_id;
                    this.setContentMendatoryBackgroundImageData(this.preferences.menu.menu_bg_image_id, eventId);
                }

                if (event.menu && event.menu.menu_bg_image_type) {
                    this.bgprop = this.preferences.menu.menu_bg_image_type = event.menu.menu_bg_image_type;
                }

                if (event.menu && event.menu.menu_content_mandatory_list) {
                    if (event.menu.menu_content_mandatory_list.length == 1) {
                        this.menu_content_mandatory_list_length = event.menu.menu_content_mandatory_list.length;
                        this.preferences.menu.menu_content_mandatory_list = event.menu.menu_content_mandatory_list;
                    } else {
                        this.menu_content_mandatory_list_imageSlider_length = event.menu.menu_content_mandatory_list.length;
                        this.preferences.menu.menu_content_mandatory_list = event.menu.menu_content_mandatory_list;
                    }
                }

                if (event.menu && event.menu.menu_content_mandatory_list) {
                    this.setContentMendatoryMenuData(event.menu.menu_content_mandatory_list.length, eventId);
                }
                if (event.menu && event.menu.menu_type == "MENU0002") {
                    this.prop1 = "showForm2";
                } else {
                    this.prop1 = "showForm1";
                }


            } else {
                // this.router.navigate([Constants.WELCOME_URL]);
            }
        });
    }

    setContentMendatoryMenuData(mcmlLength, eventId) {
        if ((this.prop2)) {
            for (var i = 0; i < 1; i++) {
                this.menuid = this.preferences.menu.menu_content_mandatory_list[i];
                this.menuTypeService.getContentMendatoryMenuIdData(this.preferences.menu.menu_content_mandatory_list[i], eventId).subscribe(event => {
                    if (event) {
                        this.contentsMandatory3 = event;
                        if (event.fileUrl) {
                            this.contentsMandatory3.fileUrl = event.fileUrl;
                        }
                    }
                });

            }
        }
    }

    setContentMendatoryCustomLogoData(custom_logo_id, eventId) {
        if (this.preferences.custom_logo.custom_logo_id) {
            this.menuTypeService.getContentMendatoryCustomLogoIdData(this.preferences.custom_logo.custom_logo_id, eventId).subscribe(event => {
                if (event) {
                    this.contentsMandatory1 = event;
                }
            });
        }
    }

    setContentMendatoryBackgroundImageData(menu_bg_image_id, eventId) {
        if (this.preferences.menu.menu_bg_image_id) {
            this.menuTypeService.getContentMendatoryBackgroundImageData(this.preferences.menu.menu_bg_image_id, eventId).subscribe(event => {
                if (event) {
                    this.contentsMandatory2 = event;
                }
            });
        }
    }

    // Custom Logo FileUpload Event Fired ///
    myUploader(event) {
        this.message = null;
        this.imageFile = event.files[0];
        if (this.imageFile) {
            if (this.showLogo) {
                this.contentsMandatory1.category = Constants.CONTENT_M_TYPE_LOGO;
            }
            for (let file of event.files) {

                if ((this.matchCustomLogoFileName = file.name) != (this.contentsMandatory1.filename) || (this.contentsMandatory1.filename == null)) {
                    this.contentsMandatory1.filename = file.name;
                    //let extension = file.type;
                    let x = this.contentsMandatory1.filename.split(".");
                    this.contentsMandatory1.extension = x[1];
                    this.contentsMandatory1.sizeInBytes = file.size;
                    //this.uploadedFiles.push(file);
                    this.currentFileUpload1 = new FileUpload(file);
                    let uploadTask = this.menuTypeService.pushUpload(
                        this.currentFileUpload1,
                        this.contentsMandatory1.eventId,
                        this.contentsMandatory1.category
                    );

                    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
                        (snapshot) => {
                            // upload in progress
                            this.disableButton = false;
                            this.message = "File Uploading...";
                            this.currentFileUpload1.progress = Math.floor((uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100)
                        },
                        (error) => {
                            // upload failed
                            this.disableButton = true;
                            console.log(error)
                        },
                        () => {
                            //upload success
                            this.message = null;
                            this.currentFileUpload1.url = uploadTask.snapshot.downloadURL;
                            this.contentsMandatory1.fileUrl = this.currentFileUpload1.url;
                            let logoId = this.menuTypeService.addCustomLogoDetails(this.contentsMandatory1);

                            if (!this.preferences.custom_logo) {
                                this.preferences.custom_logo = new CustomLogo();
                            }
                            if (logoId) {
                                this.preferences.custom_logo.custom_logo_id = logoId;
                                this.custom_logo_id = logoId;
                                this.message = "File Uploaded Successfully";
                                this.disableButton = true;
                            }
                        }
                    );
                }
            }
        }
    }

    // BackgroundImage FileUpload Event Fired ///
    myBGUploader(event) {
        this.message = null;
        this.imageFile = event.files[0];
        if (this.imageFile) {
            if (this.bgprop1 == 'BG002') {
                this.contentsMandatory2.category = Constants.CONTENT_M_TYPE_BG;
            }

            for (let file of event.files) {
                if ((this.matchCustomLogoFileName = file.name) != (this.contentsMandatory2.filename) || (this.contentsMandatory2.filename == null)) {
                    this.contentsMandatory2.filename = file.name;
                    //let extension = file.type;
                    let x = this.contentsMandatory2.filename.split(".");
                    this.contentsMandatory2.extension = x[1];
                    this.contentsMandatory2.sizeInBytes = file.size;
                    //this.uploadedFiles.push(file);
                    this.currentFileUpload2 = new FileUpload(file);
                    let uploadTask = this.menuTypeService.pushUpload(
                        this.currentFileUpload2,
                        this.contentsMandatory1.eventId,
                        this.contentsMandatory2.category
                    );

                    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
                        (snapshot) => {
                            // upload in progress
                            this.disableButton = false;
                            this.message = "File Uploading...";
                            this.currentFileUpload2.progress = Math.floor((uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100)
                        },
                        (error) => {
                            // upload failed
                            this.disableButton = true;
                            console.log(error)
                        },
                        () => {
                            //upload success
                            this.currentFileUpload2.url = uploadTask.snapshot.downloadURL;
                            this.contentsMandatory2.fileUrl = this.currentFileUpload2.url;
                            this.contentsMandatory2.eventId = this.evntID;
                            let bgId = this.menuTypeService.addBgImageDetails(this.contentsMandatory2, this.evntID);
                            if (!this.preferences.menu) {
                                this.preferences.menu = new Menu();
                            } if (bgId) {
                                this.preferences.menu.menu_bg_image_id = bgId;
                                this.background_id = bgId;
                                this.message = "File Uploaded Successfully";
                                this.disableButton = true;
                            }

                        }
                    );
                }

            }  //for loop end
        }
    }

    //MenuHeader FileUpload event Fired //
    myMenuUploader(event) {
        this.message = null;
        this.currentFiles = event.files;
        this.imageFile = event.files[0];
        if (this.imageFile) {
            if (this.sectionName) {
                this.contentsMandatory3.category = Constants.CONTENT_M_TYPE_MENU;
            }

            if (this.prop2) {
                this.preferences.menu.menu_header_type = this.prop2;
            }

            this.preferences.menu.menu_content_mandatory_list = new Array();

            // Image or video FileUpload Event Fired //
            for (let file of event.files) {
                if ((this.matchCustomLogoFileName = file.name) != (this.contentsMandatory3.filename) || (this.contentsMandatory3.filename == null)) {
                    this.contentsMandatory3.filename = file.name;
                    //let extension = file.type;
                    let x = this.contentsMandatory3.filename.split(".");
                    this.contentsMandatory3.extension = x[1];
                    this.contentsMandatory3.sizeInBytes = file.size;

                    //this.uploadedFiles.push(file);

                    this.currentFileUpload3 = new FileUpload(file);
                    let uploadTask = this.menuTypeService.pushUploadMenu(
                        this.currentFileUpload3,
                        this.contentsMandatory1.eventId,
                        this.contentsMandatory3.category,
                    );

                    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
                        (snapshot) => {
                            this.disableButton = false;
                            // upload in progress
                            this.message = "File Uploading...";
                            //this.uploadprogress 
                            this.currentFileUpload3.progress = Math.floor((uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100)
                        },
                        (error) => {
                            // upload failed
                            this.disableButton = true;
                            console.log(error)
                        },
                        () => {
                            // upload success
                            this.currentFileUpload3.url = uploadTask.snapshot.downloadURL;
                            this.contentsMandatory3.fileUrl = this.currentFileUpload3.url;
                            if (this.prop2 === 'Image Slider') {
                                this.images.push(this.currentFileUpload3.url);
                            }
                            this.contentsMandatory3.eventId = this.evntID;
                            let menuID = this.menuTypeService.addMenuDetails(this.contentsMandatory3, this.contentsMandatory3.eventId);
                            console.log(menuID)
                            if (menuID) {
                                this.preferences.menu.menu_content_mandatory_list.push(menuID);
                                //this.menuid = menuID;
                                this.message = "File Uploaded Successfully";
                                this.disableButton = true;
                            }
                        }
                    );
                }
            } //loop end
        }
    } // mymenuuploader end

    deleteImage(event) {
        console.log('currentFiles', this.currentFiles.length);
        this.imageFile = null;
        this.currentFileUpload3.progress = null;
    }

    deleteCustomImage() {
        this.imageFile = null;
    }

    onMenuIconTypeChange(entry) {
        console.log('onMenuIconTypeChange   ', entry);
        this.menu_type_chk = entry;
    }

    submit() {
        this.disableButton = false;
        var eventID = this.contentsMandatory1.eventId;
        this.message = null;
        this.validate();
        // if (this.evntID) {
        //     if ((this.contentsMandatory2.category === Constants.CONTENT_M_TYPE_BG && this.contentsMandatory2.filename != null) || (this.contentsMandatory1.category === Constants.CONTENT_M_TYPE_LOGO && this.contentsMandatory1.filename != null) || (this.contentsMandatory3.category === Constants.CONTENT_M_TYPE_MENU && this.contentsMandatory3.filename != null)) {
        //         this.isError = false;
        //         this.preferences.venue = this.venue;
        //         this.preferences.splash_map = this.splashMap;
        //         this.eventsService.addPreferencesDetails(eventID, this.preferences);
        //         this.message = "Updated Successfully";
        //     } else {
        this.isError = false;
        this.preferences.venue = this.venue;
        this.preferences.splash_map = this.splashMap;
        this.eventsService.addPreferencesDetails(eventID, this.preferences);
        this.message = "Updated Successfully";
        //     }
        // } else {
        //     if ((this.contentsMandatory2.category === Constants.CONTENT_M_TYPE_BG && this.contentsMandatory2.filename != null) || (this.contentsMandatory1.category === Constants.CONTENT_M_TYPE_LOGO && this.contentsMandatory1.filename != null) || (this.contentsMandatory3.category === Constants.CONTENT_M_TYPE_MENU && this.contentsMandatory3.filename != null)) {
        //         this.isError = false;
        //         this.preferences.venue = this.venue;
        //         this.preferences.splash_map = this.splashMap;
        //         this.eventsService.addPreferencesDetails(eventID, this.preferences);
        //         this.message = "Updated Successfully";
        //     } else {
        //         this.isError = false;
        //         this.preferences.venue = this.venue;
        //         this.preferences.splash_map = this.splashMap;
        //         this.eventsService.addPreferencesDetails(eventID, this.preferences);
        //         this.message = "Updated Successfully";
        //     }
        // }

        setTimeout(function () {
            this.removeSlider();
            this.message = null;
            this.disableButton = true;
            this.setPreferencesData(eventID);

        }.bind(this), 2000);

    }

    validate() {

        this.preferences.custom_logo.has_custom_logo = this.showLogo;
        this.preferences.custom_logo.hideText = this.hide_text;
        this.preferences.custom_logo.widthIos = this.widthIos;
        this.preferences.custom_logo.custom_logo_has_tint = this.tintLogo;

        console.log('before     ' + this.preferences.menu.menuIconType);

        if (this.menu_type_chk) {
            this.preferences.menu.menuIconType = this.menu_type_chk;
        } else {
            console.log('not set icon type')
        }
        console.log('after     ' + this.preferences.menu.menuIconType);

        if (this.showLogo && this.preferences.custom_logo) {
            this.contentsMandatory1.category = Constants.CONTENT_M_TYPE_LOGO;
            // this.preferences.custom_logo.has_custom_logo = true;
        }

        // if (!this.showLogo && this.preferences.custom_logo) {
        //     this.preferences.custom_logo.has_custom_logo = false;
        // }

        this.preferences.menu.menu_bg_image_has_blur = this.blurImage;
        if (this.blurImage && this.preferences.menu) {
            // this.preferences.menu.menu_bg_image_has_blur = true;
            this.preferences.menu.menu_bg_image_blur_index = this.blurIndex;
        }

        // if (!this.blurImage && this.preferences.menu) {
        //     this.preferences.menu.menu_bg_image_has_blur = false;
        //     this.blurIndex = null;
        // }

        // if (this.removeCard && this.preferences.menu) {
        //     this.preferences.menu.menu_icon_remove_card = true;
        // }

        // if (!this.removeCard && this.preferences.menu) {
        //     this.preferences.menu.menu_icon_remove_card = false;
        // }
        this.preferences.menu.menu_icon_remove_card = this.removeCard;

        // if (this.selectCardFlag && this.preferences.menu) {
        //     this.preferences.menu.has_custom_card_color = this.selectCardFlag;
        // }

        // if (!this.selectCardFlag && this.preferences.menu) {
        this.preferences.menu.has_custom_card_color = this.selectCardFlag;
        // }

        // if (this.iconCardFlag && this.preferences.menu) {
        //     this.preferences.menu.has_custom_icon_color = this.iconCardFlag;
        // }

        // if (!this.iconCardFlag && this.preferences.menu) {
        this.preferences.menu.has_custom_icon_color = this.iconCardFlag;
        // }

        // if (this.iconTextFlag && this.preferences.menu) {
        //     this.preferences.menu.has_custom_icon_text_color = this.iconTextFlag;
        // }

        // if (!this.iconTextFlag && this.preferences.menu) {
        this.preferences.menu.has_custom_icon_text_color = this.iconTextFlag;

        // if (this.showBgType && this.preferences.menu) {
        //     console.log(this.showBgType)
        this.preferences.menu.menu_has_custom_bg = this.showBgType;
        // }

        this.preferences.menu.menu_has_header = this.sectionName;
        if (this.sectionName && this.preferences.menu) {
            this.contentsMandatory3.category = Constants.CONTENT_M_TYPE_MENU;
            // this.preferences.menu.menu_has_header = true;
        }

        // if (!this.sectionName && this.preferences.menu) {
        //     this.preferences.menu.menu_has_header = false;
        // }


        if (this.preferences.menu) {
            this.preferences.menu.menu_bg_image_type = this.bgprop;
        }
        // if (this.bgprop == 'partial' && this.preferences.menu) {
        //     this.preferences.menu.menu_bg_image_type = this.bgprop;
        // }

        // if (this.bgprop == 'fullscreen' && this.preferences.menu) {
        //     this.preferences.menu.menu_bg_image_type = this.bgprop;
        // }

        if (this.bgprop1 == 'BG001' && this.preferences.menu) {
            this.preferences.menu.menu_bg_type = this.bgprop1;
        }

        if (this.bgprop1 == 'BG002' && this.preferences.menu) {
            this.contentsMandatory2.category = "BGImage";
            this.preferences.menu.menu_bg_type = this.bgprop1;
        }

        if (this.prop1 == "showForm2" && this.preferences.menu) {
            this.preferences.menu.menu_type = 'MENU0002';
        }

        if (this.prop1 == "showForm1" && this.preferences.menu) {
            this.preferences.menu.menu_type = 'MENU0001';
        }

        if (this.prop2 === "Image") {
            this.preferences.menu.menu_header_type = 'image';
        }

        if (this.prop2 === "Video") {
            this.preferences.menu.menu_header_type = 'video';
        }

        if (this.prop2 === "Image Slider") {
            this.preferences.menu.menu_header_type = 'imageSlider';
        }

        if (this.prop2 === "Youtube") {
            this.preferences.menu.menu_header_type = 'youtubeVideo';
        }
    }
}


// WEBPACK FOOTER //
// /workspace/backend-server/src/app/event/menu-type/menu-type.ts